import { lazy } from 'react';

const LazyPrivacyPolicy = lazy(() => import('./privacy-policy'));
export default LazyPrivacyPolicy;
